
export default [

    
  {
    path: 'appAll',
    component: resolve => { require(['../views/oms/appAll'], resolve); },
  },
  
  {
    path: 'dict',
    component: resolve => { require(['../views/oms/dict'], resolve); },
  },
  {
    path: 'menu',
    component: resolve => { require(['../views/oms/menu'], resolve); },
  },
  {
    path: 'role',
    component: resolve => { require(['../views/oms/role'], resolve); },
  },
  {
    path: 'account',
    component: resolve => { require(['../views/oms/account'], resolve); },
  },
  {
    path: 'AIVendor',
    component: resolve => { require(['../views/oms/AI-vendor'], resolve); },
  },
  {
    path: 'AIModel',
    component: resolve => { require(['../views/oms/AI-model'], resolve); },
  },
  {
    path: 'tenant',
    component: resolve => { require(['../views/oms/tenant'], resolve); },
  },
  {
    path: 'tenantAccount',
    component: resolve => { require(['../views/oms/tenant-account'], resolve); },
  },
  {
    path: 'tenantModel',
    component: resolve => { require(['../views/oms/tenant-model'], resolve); },
  },
  {
    path: 'totalQuantity',
    component: resolve => { require(['../views/oms/TokensStatistics/total-quantity'], resolve); },
  },
  // {
  //   path: 'totalModel',
  //   component: resolve => { require(['../views/oms/TokensStatistics/total-model'], resolve); },
  // },
  // {
  //   path: 'totalTenant',
  //   component: resolve => { require(['../views/oms/TokensStatistics/total-tenant'], resolve); },
  // },
  {
    path: 'totalTenantDay',
    component: resolve => { require(['../views/oms/TokensStatistics/total-tenant-day'], resolve); },
  },
  {
    path: 'totalTenantMonth',
    component: resolve => { require(['../views/oms/TokensStatistics/total-tenant-month'], resolve); },
  }
]